import React from 'react';
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
import {openModal, closeModal} from 'Skelet/src/modules/functions.js'
import {days_to_go, calc_age} from 'Skelet/src/modules/time_ago.js'
import ModalCreateSizes from './ModalCreateSizes.js'
import ModalCreateJourney from './ModalCreateJourney.js'
import ModalCRUD from 'Skelet/src/components/ModalCRUD.js'


class Body extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "sizes_list", "GET", config.api_url+"/sizes?t="+this.props.session_token);
      this.props.fetchDataIfReady(config.api_token, "journey_list", "GET", config.api_url+"/journey?t="+this.props.session_token);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "sizes_list", "GET", config.api_url+"/sizes?t="+nextProps.session_token);
      this.props.fetchDataIfUndefined(config.api_token, "journey_list", "GET", config.api_url+"/journey?t="+nextProps.session_token);
    }
  }

  render() {
    let current_weight = "", stats_card = null, sizes_card = null, journey_card = null, user_data = this.props.apiData["login"]["data"], page_cards = this.props.apiData["sizes_list"], journey = this.props.apiData["journey_list"];

    // "Als je bijvoorbeeld 10 kilo kwijt wil, verdeel dit dan in 3 tussenstappen. Bijvoorbeeld eerst werk je naar 5 kilo minder, daarna naar de 8 kilo en tenslotte naar de 10 kilo minder."
    let body_introcard = <div className="card" style={{background:"#15a033",color:"#fff"}}>"Hou dagelijks je metingen bij, of minstens een paar keer per week, en krijg meer overzicht. Daarnaast kun je een streefgewicht invullen om een doel te stellen. Stel realistische doelen en maak kleine stappen, voeg bijvoorbeeld eerst een nieuw streefgewicht toe om 5 kilo af te vallen in 10 weken."</div>;

    if(page_cards !== undefined && !page_cards.isFetching && page_cards.data !== [] && page_cards.data[0]) {
      current_weight = page_cards.data[0].weight.toString().replace(".", ",")+" kg";
    } else {
      current_weight = "Voeg een nieuwe meting toe."
    }
    let gender, age, length;
    gender = age = length = <div>Ga naar <Link to="/instellingen">Instellingen</Link> om dit in te vullen.</div>;

    if(user_data.parameters !== null) {
      let user_parameters = JSON.parse(user_data.parameters);
      if(user_parameters["gender"]) gender = (user_parameters["gender"] === "f") ? "Vrouw" : "Man";
      if(user_parameters["birthdate"]) age = calc_age(user_parameters["birthdate"])+" jaar";
      if(user_parameters["length"]) length = user_parameters["length"]+" cm";
    }

    stats_card = <div className="card">
      <div className="card-layout">
        <div className="card-layout-div50 card-layout-div25-md" style={{fontSize:".7em"}}>Geslacht</div>
        <div className="card-layout-div75">{gender}</div>
      </div>
      <div className="card-layout">
        <div className="card-layout-div50 card-layout-div25-md" style={{fontSize:".7em"}}>Leeftijd</div>
        <div className="card-layout-div75">{age}</div>
      </div>
      <div className="card-layout">
        <div className="card-layout-div50 card-layout-div25-md" style={{fontSize:".7em"}}>Lengte</div>
        <div className="card-layout-div75">{length}</div>
      </div>
      <div className="card-layout">
        <div className="card-layout-div50 card-layout-div25-md" style={{fontSize:".7em"}}>Gewicht</div>
        <div className="card-layout-div75">{current_weight}</div>
      </div>
    </div>;

    if(page_cards !== undefined) {
      let cards = [];
      if(page_cards.data[0] !== undefined) {
        for(let i = 0; i < 3; i++) {
          let item = page_cards.data[i];
          if(item !== undefined) {

            let dt = new Date(item.date);
            let date_txt = dt.getDate()+" "+dt.toLocaleString('default', { month: 'long' })+" "+dt.getFullYear();

            cards.push(<div key={"1k"+i} style={{marginBottom:"12px"}}>
              <div>{item.weight.toString().replace(".", ",")} kg <small style={{opacity:".6"}}>({date_txt})</small></div>
            </div>);
          }
        }
      } else {
        cards.push(<div key={"2k"}><p style={{opacity:".5"}}>Voeg je eerste meting toe.</p></div>);
      }
      let sizes_left = null;
      if(page_cards.data.length > 3) {
        let szl = page_cards.data.length - 3;
        sizes_left = "+ "+szl+" metingen.";
      }
      sizes_card = <div className="card">
        <div className="index-actions">
          <button className="btn btn-e btn-fat" onClick={() => openModal(this, null, null, "modal_create_sizes_open")}>nieuw gewicht</button>
          <button className="btn btn-e btn-fat" onClick={() => openModal(this, null, null, "crud_modal_sizes_open")}>beheren</button>
        </div>{cards}<div><small style={{opacity:".6"}}>{sizes_left}</small></div><ModalCreateSizes shouldShow={this.state.modal_create_sizes_open} close={() => closeModal(this, "modal_create_sizes_open")} /><ModalCRUD config={config} shouldShow={this.state.crud_modal_sizes_open} close={() => closeModal(this, "crud_modal_sizes_open")} delete api_block="sizes_list" empty_text='Klik op "nieuwe meting" om je eerste meting toe te voegen.' main_property="weight" main_property_formatting="kg" sub_property="date" sub_property_formatting="date_d-ml-y" api_endpoint_delete="/sizes" /></div>;
    }

    let jrny = null, jrny_hist = null;
    if(journey !== undefined && !journey.isFetching && journey.data !== [] && journey.data[0]) {
      let journey_data = journey.data[0];
      let sd = new Date(journey_data.start_date);
      let start_date_txt = sd.getDate()+" "+sd.toLocaleString('default', { month: 'long' })+" "+sd.getFullYear();
      let gd = new Date(journey_data.goal_date);
      let goal_date_txt = gd.getDate()+" "+gd.toLocaleString('default', { month: 'long' })+" "+gd.getFullYear();
      let total_weight = journey_data["start_weight"] - journey_data["goal_weight"];
      let days_left = days_to_go(journey_data["goal_date"], journey_data["start_date"]) + 1;
      let wl_weekly = Math.ceil(total_weight.toFixed(1) / (days_left / 7) * 1000);
      let wl_speed_warning = (wl_weekly > 1000) ? true : false;

      jrny = <div style={{marginBottom:"12px"}}>
        <div className="card-layout">
          <div className="card-layout-div50 card-layout-div25-md" style={{fontSize:".7em"}}>Startgewicht</div>
          <div className="card-layout-div75">{journey_data["start_weight"].toString().replace(".", ",")} kg <small style={{opacity:".6"}}>({start_date_txt})</small></div>
        </div>
        <div className="card-layout">
          <div className="card-layout-div50 card-layout-div25-md" style={{fontSize:".7em"}}>Streefgewicht</div>
          <div className="card-layout-div75">{journey_data["goal_weight"].toString().replace(".", ",")} kg <small style={{opacity:".6"}}>({goal_date_txt})</small></div>
        </div>
        <div className="card-layout">
          <div className="card-layout-div50 card-layout-div25-md" style={{fontSize:".7em"}}>Aantal dagen</div>
          <div className="card-layout-div75">{days_left}</div>
        </div> 
        <div className="card-layout">
          <div className="card-layout-div50 card-layout-div25-md" style={{fontSize:".7em"}}>Gram per dag / week</div>
          <div className="card-layout-div75" style={wl_speed_warning ? {color:"#ff6353"} : null}>{Math.ceil(total_weight.toFixed(1) / days_left * 1000).toString().replace(".", ",")} gram per dag / {wl_weekly.toString().replace(".", ",")} per week</div>
        </div>
      </div>;

      let jrny_hist_cards = [];
      for(let i2 = 0; i2 < 3; i2++) {
        let item = journey.data[i2];
        if(item !== undefined) {
          let dt = new Date(item.created_at);
          let date_txt = dt.getDate()+" "+dt.toLocaleString('default', { month: 'long' })+" "+dt.getFullYear()+" "+('0'+dt.getHours()).slice(-2)+":"+('0'+dt.getMinutes()).slice(-2);
          let dt2 = new Date(item.start_date);
          let date_txt2 = dt2.getDate()+" "+dt2.toLocaleString('default', { month: 'long' })+" "+dt2.getFullYear();
          let dt3 = new Date(item.goal_date);
          let date_txt3 = dt3.getDate()+" "+dt3.toLocaleString('default', { month: 'long' })+" "+dt3.getFullYear();

          jrny_hist_cards.push(<div key={"1k"+i2} style={{marginBottom:"12px"}}>
            <div>{item.start_weight.toString().replace(".", ",")} kg - {item.goal_weight.toString().replace(".", ",")} kg <small style={{opacity:".6"}}>({date_txt2} - {date_txt3})</small></div>
            <small style={{opacity:".3"}}>gemaakt: {date_txt}</small>
          </div>);
        }
      }
      let journeys_left = null;
      if(journey.data.length > 3) {
        let jnl = journey.data.length - 3;
        journeys_left = "+ "+jnl+" items.";
      }

      jrny_hist = <div><b style={{fontSize:"87%", margin:"32px 0 4px", display:"block"}}>Geschiedenis</b><div style={{background:"#f7f7f7", padding:"8px"}}>{jrny_hist_cards}<small style={{opacity:".6"}}>{journeys_left}</small></div></div>;
    } else {
      jrny = <div key={"3k"}><p style={{opacity:".5"}}>Voeg je eerste plan toe.</p></div>;
    }

    journey_card = <div className="card">
      <div className="index-actions">
        <button className="btn btn-e btn-fat" onClick={() => openModal(this, null, null, "modal_create_journey_open")}>nieuw streefgewicht</button>
      </div>{jrny}{jrny_hist}<ModalCreateJourney shouldShow={this.state.modal_create_journey_open} close={() => closeModal(this, "modal_create_journey_open")} /></div>;

    return (
      <div className="container" ref={this.setWrapperRef} style={{marginTop:"2em"}}>
        {((page_cards !== undefined && page_cards.data !== undefined && page_cards.data[0] === undefined) || (journey !== undefined && journey.data !== undefined && journey.data[0] === undefined)) && body_introcard}
        {stats_card}
        {sizes_card}
        {journey_card}
      </div>
    );
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Body)



// WEBPACK FOOTER //
// ./src/containers/Body.js